const TEST_PATIENT_NHS_NUMBER = "7777777777";

export const isTestPatient = (nhsNumber?: string) => {
    return nhsNumber === TEST_PATIENT_NHS_NUMBER;
};
